import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M8.775 3.83911V13.711M13.7109 8.77505H3.83906",
		stroke: "currentColor",
		strokeWidth: 1.09687,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAdd;
